import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneInput.scss';

type Props = {
  onPhoneChange: (phone: string) => void;
  selectedPhone: string;
  title?: string;
  placeholder?: string;
  isDisabled?: boolean;
};

const PhoneInputComp = ({
  title,
  selectedPhone,
  onPhoneChange,
  placeholder,
  isDisabled = false,
}: Props) => {
  return (
    <div className='phone-input-container'>
      {title && <div className='title'>{title}</div>}
      <PhoneInput
        country={'gb'}
        preferredCountries={['gb']}
        placeholder={placeholder}
        value={selectedPhone}
        onChange={(phone) => onPhoneChange(phone)}
        inputClass='custom-phone-input'
        disabled={isDisabled}
      />
    </div>
  );
};

export default PhoneInputComp;
